import React from 'react';
import { getAuth } from 'firebase/auth';
import { VStack } from 'native-base';

import {
  PublicProfieHeader,
  PublicProfieFriendActions,
  ChatListCollectionView,
  FriendListTableView,
} from '../../';

import { User, Flair } from '@breakroom-nx/classes';
import { FlairType } from '@breakroom-nx/helpers';
export interface PublicProfieProps {
  readonly user: User;
  readonly isClient: boolean;
  readonly isLoading: boolean;
}

export function PublicProfie({ user, isClient, isLoading }: PublicProfieProps) {
  const auth = getAuth();
  const flair: Flair = new Flair(FlairType.Leader);
  return (
    <VStack space={5} overflow={'hidden'}>
      <VStack px={8} space={5}>
        <PublicProfieHeader
          user={user}
          flair={flair}
          isClient={isClient}
          isLoading={isLoading}
        />
        {!isClient && !auth.currentUser?.isAnonymous ? (
          <VStack alignItems={'center'}>
            <PublicProfieFriendActions user={user} />
          </VStack>
        ) : null}
      </VStack>

      <ChatListCollectionView user={user} isClient={isClient} />
      <FriendListTableView user={user} />
    </VStack>
  );
}

export default React.memo(PublicProfie);
